import axios from 'axios'
import {BUSCAR_PRESTADORES_SIMPLES} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function buscarPrestadoresSimples (codigoEmpresa) {
  let url = `${URL}/prestador/empresa/${codigoEmpresa}/simples`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_PRESTADORES_SIMPLES,
        payload: response

      })
  );
}
